import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="page-scroll" href="#page-top">
          <img src={"img/ads4perm.svg"} alt="icon for ads4perm" />
          </a>
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#services" className="page-scroll">
                OUR SERVICES
              </a>
            </li>
            <li>
              <a href="#about" className="page-scroll">
                ABOUT US
              </a>
            </li>
            <li>
              <a href="#faq" className="page-scroll">
                FAQ
              </a>
            </li>
            <li>
              <a href="#quote-request" className="page-scroll">
                REQUEST A QUOTE
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                CONTACT US
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
